import { render, staticRenderFns } from "./UserSettingsAccount.vue?vue&type=template&id=bf3277b0&scoped=true&"
import script from "./UserSettingsAccount.vue?vue&type=script&lang=js&"
export * from "./UserSettingsAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsAccount.vue?vue&type=style&index=0&id=bf3277b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3277b0",
  null
  
)

export default component.exports